import dynamic from "next/dynamic";
import { Suspense, useState } from "react";

import usePreLead from "./usePreLead";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";

const Errors = dynamic(() => import("../../../../components/Errors"), {
  suspense: true,
});
const Thankyou = dynamic(() => import("./ThankYou"), {
  suspense: true,
});

const Index = () => {
  const [sub, setSub] = useState(false);
  const { errors, handleSubmit, isDirty, onSubmit, register } = usePreLead(
    () => {
      setSub(true);
    }
  );

  return sub === false ? (
    <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-6">
      <div>
        {Object.values(errors).length !== 0 && (
          <Suspense
            fallback={
              <>
                <p>Loading...</p>
              </>
            }
          >
            <Errors errors={Object.values(errors)} />
          </Suspense>
        )}
      </div>

      <div className="flex gap-1">
        <input
          {...register("firstName")}
          className="bg-white outline-none border-none px-2 py-[0.4rem] w-1/2 "
          placeholder="First Name"
        />
        <input
          {...register("lastName")}
          className="bg-white outline-none border-none px-2 py-[0.4rem] w-1/2"
          placeholder="Last Name"
        />
      </div>
      <input
        {...register("email")}
        className="bg-white outline-none border-none px-2 py-[0.4rem]"
        placeholder="Email"
      />

      <PhoneInput
        {...register("phone")}
        placeholder="Enter phone number"
        defaultCountry={"CA"}
        limitMaxLength
        countryCallingCodeEditable={false}
        className="bg-white outline-none border-none px-2 py-[0.6rem]"
        onChange={() => {}}
      />

      <div className="flex flex-col gap-1">
        <p className="">Are you a Realtor?</p>

        <div className="flex gap-4">
          <div className="flex gap-1">
            <input
              id="yes"
              {...register("isRealtor")}
              value={"true"}
              type="radio"
            />
            <label htmlFor="yes">Yes</label>
          </div>
          <div className="flex gap-1">
            <input
              id="no"
              {...register("isRealtor")}
              value={"false"}
              type="radio"
            />
            <label htmlFor="No">No</label>
          </div>
        </div>
      </div>
      <input
        {...register("message")}
        className="bg-white outline-none border-none px-2 py-[0.4rem]"
        placeholder="Message"
      />
      <button disabled={!isDirty} className="bg-primary text-white py-2">
        Submit
      </button>
    </form>
  ) : (
    <Suspense>
      <Thankyou />
    </Suspense>
  );
};
export default Index;
